import { SpecializationPoints } from 'specialization';
import React, { FC, useContext, useState } from 'react';
import { useEffectAsync } from 'component_utils/utils';
import { Spinner } from 'reactstrap';
import logo from 'images/beelogo.png';
import GenericSpecializations from 'specialization/generic';

export let be_specializations: SpecializationPoints
declare global {
  interface Window {
    be_specializations: SpecializationPoints;
  }
}

const SpecializationContext = React.createContext<SpecializationPoints>(GenericSpecializations);

export function useSpecializations() {
  return useContext(SpecializationContext);
}

export const SpecializationProvider: FC = ({ children }) => {
  const [specializations, setSpecializations] = useState<SpecializationPoints>(null)

  window.be_specializations = specializations;
  be_specializations = specializations;

  useEffectAsync(async () => {
    let loadedSpecialization = GenericSpecializations

    // we just try to load the specialization...
    try {
      // Dynamically import hashed chunk
      const entryUrl = `/userdata/frontend_bundle/main.js?v=${Date.now()}`
      const existsReq = await fetch(entryUrl, { method: "HEAD" })
      if (existsReq.ok) {
        const mod = await window.__customizer_import(entryUrl)
        loadedSpecialization = mod.default as SpecializationPoints;
      }
    } catch (e) {
      alert("Could not load specializations")
      console.error(e)
    }

    // now just set it and finished
    console.log("Loaded specialization with identifier '" + loadedSpecialization.identifier + "'")
    setSpecializations(() => loadedSpecialization)
  }, [])


  let content = children;
  if (!specializations) {
    const size = '7rem';
    const centeredDivProps: any = {
      style: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      },
    };  
    content = (
      <>
        <div {...centeredDivProps}>
          <Spinner style={{ width: size, height: size }} type="grow" color="primary" />
        </div>
        <div {...centeredDivProps}>
          <img src={logo} className="brandLogo" alt="BeEfficient logo" />
        </div>
      </>
    )
  }
  return (
    <SpecializationContext.Provider value={specializations}>
      {content}
    </SpecializationContext.Provider>
  );
};
